import { useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import HotBoard from './components/HotBoard';
import Timeline from './components/Timeline';
import EventGrid from './components/EventGrid';
import AnnualSummary from './components/AnnualSummary';
import MajorReviews from './components/MajorReviews';
import FlipGallery from './components/FlipGallery';
import AboutSection from './components/AboutSection';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';

export default function Home() {
  const [query, setQuery] = useState('');

  return (
    <div className="bg-background-50">
      <Navbar onSearch={setQuery} />
      <main>
        <Hero onSearch={setQuery} />
        <HotBoard />
        <Timeline />
        <EventGrid query={query} />
        <AnnualSummary />
        <MajorReviews />
        <FlipGallery />
        <AboutSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}